import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { ScheduledReportService } from 'src/app/core/services/reporting/scheduled-report.service';

/**
 * HTTP Interceptor to mock the scheduled reports datatable API endpoint
 * This intercepts requests to the datatable endpoint and returns mock data
 *
 * To disable (when backend is ready):
 * - Remove this interceptor from the providers array
 * - The actual HTTP requests will go through to the real backend
 */
export const scheduledReportsMockInterceptor: HttpInterceptorFn = (req, next) => {
  const scheduledReportService = inject(ScheduledReportService);

  // Intercept only the datatable endpoint
  if (req.url.includes('/v2/reporting/schedules/datatable/')) {
    console.log('[Mock Interceptor] Intercepting datatable request:', req.url);

    // Extract query parameters
    const params: any = {};
    req.params.keys().forEach(key => {
      params[key] = req.params.get(key);
    });

    // Use the service method to get mock data
    return scheduledReportService.getScheduledReportsForDatatable(params).pipe(
      delay(300),
      // Convert to HttpResponse
      // @ts-ignore
      map((body: any) => new HttpResponse({ status: 200, body }))
    );
  }

  // Pass through all other requests
  return next(req);
};
